export default "__VITE_ASSET__CFetAcVr__"